<ds-modal #tpl [ds-modal-trigger-for]="tpl" [isModalOpen]="caseList.length > 0 || orderList.length > 0"
          id="case-selection-dialog" (dismiss)="close()" (modalDismiss)="close()" [dimensionsConfig]="{height: '90vh'}">
  <ds-box-header>{{ 'case.selectCase' | translate }}</ds-box-header>

  <ds-box-content class="overlay-box-content">
    <div class="button-bar">
      <button ds-button variant="primary" (click)="newServiceCaseSelected()">{{ "case.new" | translate }}</button>
    </div>

    @if (orderList.length === 0) {
      <p class="text-regular">{{ 'case.existingCases' | translate }}</p>
    } @else if (caseList.length === 0) {
      <p class="text-regular">{{ 'case.existingDmsOrders' | translate }}</p>
    } @else {
      <p class="text-regular">{{ 'case.existingCasesAndDmsOrders' | translate }}</p>
    }

    <!-- Separate @if blocks for labels and contents to ensure correct content projection into ds-tabs slots -->
    <ds-tabs>
      @if (caseList.length > 0) {
        <ds-tabs-label for="existing-cases">{{ 'categories.serviceCases' | translate }} ({{ caseList.length }})
        </ds-tabs-label>
      }
      @if (caseList.length > 0) {
        <ds-tabs-content id="existing-cases">
          <app-service-case-for-vin-selection [caseList]="caseList"
                                              (existingServiceCaseSelected)="serviceCaseSelected($event)"/>
        </ds-tabs-content>
      }
      @if (orderList.length > 0) {
        <ds-tabs-label for="existing-orders">{{ 'dms.ordersOrAppointments' | translate }} ({{ orderList.length }})
        </ds-tabs-label>
      }
      @if (orderList.length > 0) {
        <ds-tabs-content id="existing-orders">
          <app-dms-order-for-vin-selection [orderList]="orderList"
                                           (newCaseWithOrder)="orderSelected($event)"/>
        </ds-tabs-content>
      }
    </ds-tabs>
  </ds-box-content>

  <ds-box-footer>
    <button ds-button variant="outline" (click)="close()">{{ 'common.cancel' | translate }}</button>
  </ds-box-footer>
</ds-modal>
